import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c9612b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Question__Inner section__inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Question__Background color--1" }, null, -1))
const _hoisted_3 = { class: "Question__Subinner section__subinner" }
const _hoisted_4 = { class: "Question__Left" }
const _hoisted_5 = { class: "Question__Number color--4" }
const _hoisted_6 = { class: "color--4" }
const _hoisted_7 = { class: "color--2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "base" }
const _hoisted_10 = { class: "hover" }
const _hoisted_11 = { class: "wrong" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-wrong" })
], -1))
const _hoisted_13 = { class: "correct" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-correct" })
], -1))
const _hoisted_15 = { class: "Question__Right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timer = _resolveComponent("Timer")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!

  return (_openBlock(), _createBlock(_component_FocusTrap, { active: _ctx.active }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass({ 'Question': true, 'is-answered': _ctx.response !== null, 'wait-answer': !_ctx.isCorrected, 'show-correction': _ctx.isCorrected })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.index) + " — " + _toDisplayString(_ctx.total), 1),
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.question.title), 1),
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.options, (option) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `question-option-${_ctx.index}-${option.slug}`
                  }, [
                    _createElementVNode("button", {
                      onClick: (event) => { _ctx.onAnswer(event, option.slug); },
                      class: _normalizeClass({ 'answer': !_ctx.isCorrected && _ctx.response?.answer === option.slug, 'correct': _ctx.isCorrected && _ctx.response?.solution.includes(option.slug), 'wrong': _ctx.isCorrected && !_ctx.response?.solution.includes(option.slug) && _ctx.response?.answer === option.slug })
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(option.text), 1),
                      _createElementVNode("span", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(option.text), 1)
                      ]),
                      _createElementVNode("span", _hoisted_11, [
                        _createElementVNode("span", null, [
                          _hoisted_12,
                          _createTextVNode(_toDisplayString(option.text), 1)
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, [
                        _createElementVNode("span", null, [
                          _hoisted_14,
                          _createTextVNode(_toDisplayString(option.text), 1)
                        ])
                      ])
                    ], 10, _hoisted_8)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Timer, {
                ref: "timer",
                question: _ctx.question,
                active: _ctx.active,
                index: _ctx.index,
                onTimeElapsed: _ctx.timeElapsed
              }, null, 8, ["question", "active", "index", "onTimeElapsed"])
            ])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["active"]))
}